import React from 'react';

import { useQuery } from '@tanstack/react-query';
import { get } from 'lodash';

import Select from '../Select';

import convertObjectToArray from '../../../helpers/convertObjectToArray';

export default function SelectWithFetchableOptions({
  label,
  name,
  value,
  setFieldValue,
  onBlur,
  error,
  touched,
  link,
  fetchOptions,
  tabindex,
  readOnly,
  hideIfNoOptions,
  fixedPosition,
  style,
  className,
  nullable,
  tooltipSize,
  tooltipPosition,
  tooltip,
}) {
  const { data } = useQuery({
    queryKey: fetchOptions.key,
    queryFn: fetchOptions.queryFn,
    enabled: !fetchOptions.disabled,
  });

  // Sometimes the backend is returning an object resembling an array, with numeric properties, rather than a conventional array. This fix is to ensure that the options are always an array.
  const validatedData = convertObjectToArray(data);

  let options = validatedData?.map?.((item) => ({
    value: fetchOptions.valueKey ? get(item, fetchOptions.valueKey) : item.id,
    label:
      typeof fetchOptions.labelKey === 'function'
        ? fetchOptions.labelKey(item)
        : get(item, fetchOptions.labelKey),
  }));

  let filteredValue = value;

  if (nullable) {
    options = [
      {
        value: null,
        label: '-',
      },
      ...(options ?? []),
    ];
  }

  // eslint-disable-next-line eqeqeq
  if (options && !options.find((option) => option.value == value)) {
    filteredValue = '';
  }

  if (
    hideIfNoOptions &&
    (!options?.length || (nullable && options.length === 1))
  ) {
    return null;
  }

  return (
    <Select
      readOnly={readOnly}
      label={label}
      name={name}
      options={options}
      value={filteredValue}
      setFieldValue={setFieldValue}
      onBlur={onBlur}
      error={error}
      touched={touched}
      link={link}
      tabindex={tabindex}
      fixedPosition={fixedPosition}
      style={style}
      className={className}
      tooltipSize={tooltipSize}
      tooltipPosition={tooltipPosition}
      tooltip={tooltip}
    />
  );
}
